import React from 'react';
import TeacherLayout from "@/components/layout/teacher/teacherLayout";
import {URLS} from "@/lib/urls";
import {useApiReadTeacherWeeklyClass} from "@/api/dashboard";
import WeeklySchedule from "@/pages/teacher/weekly/WeeklySchedule";
import RenderLoading from "@/components/render-if-loading";

function TeacherWeeklyPage(props) {
    const {data: weeklyClass, isPending} = useApiReadTeacherWeeklyClass()
    return (
        <TeacherLayout pageTitle={'برنامه هفتگی'} backTo={URLS.teacher.dashboard}>
            <RenderLoading loading={isPending} skeleton={true}>
                <WeeklySchedule dashboardData={weeklyClass}/>
            </RenderLoading>
        </TeacherLayout>
    );
}

export default TeacherWeeklyPage;